import { CardProduct } from "@app/components/card-product";
import { config } from "@app/config";
import { useSearchspringRecommendResults } from "@app/hooks/use-searchspring-recommend-results";
import { GOOGLE_ANALYTIC_EVENTS, INTERACTION_EVENTS, INTERACTION_TYPES, MODAL_EVENTS } from "@app/lib/events";
import { SearchspringRecommendProvider } from "@app/providers/searchspring";
import React, { useState, useEffect } from "react";

type CartRecommendation = {
  title: string;
  product_id: string;
  profile_id: string;
};

export type Props = {
  config: typeof config;
  cart_recommendations: CartRecommendation;
};

function CartRecommendationsResultGrid({ recommendations }: { recommendations: CartRecommendation }) {
  const results = useSearchspringRecommendResults();

  useEffect(() => {
    /** Used to trigger the interaction-impression event for Google Analytics */
    document.addEventListener(MODAL_EVENTS.OPEN, () => {
      if (!results.length) return;
      results.map((result) => {
        document.dispatchEvent(
          new CustomEvent(INTERACTION_EVENTS.INTERACTION_IMPRESSION, {
            detail: {
              event: GOOGLE_ANALYTIC_EVENTS.INTERACTION_EVENT_IMPRESSION,
              eventAction: INTERACTION_TYPES.IMPRESSION,
              eventModuleName: "add to cart recommendations",
              eventActioNText: result.name,
              eventActionIdentifier: recommendations.title,
            },
          }),
        );
      });
    });
  }, [results]);

  return (
    <div className="grid grid-cols-2 gap-x-2 gap-y-6 py-6 md:grid-cols-2 md:gap-x-6 md:gap-y-8 md:py-0 md:pt-6">
      {results?.map((result, i) => {
        return (
          <div
            onClick={() => {
              /** Used to trigger the interaction-select event for Google Analytics */
              document.dispatchEvent(
                new CustomEvent(INTERACTION_EVENTS.INTERACTION_SELECT, {
                  detail: {
                    event: GOOGLE_ANALYTIC_EVENTS.INTERACTION_EVENT_CLICK,
                    eventAction: INTERACTION_TYPES.SELECT,
                    eventModuleName: "add to cart recommendations",
                    eventActioNText: result.name,
                    eventActionIdentifier: recommendations.title,
                  },
                }),
              );
            }}
          >
            <CardProduct data={result} key={result.id} source="searchspring-recommdation" />
          </div>
        );
      })}
    </div>
  );
}

export function CartRecommendations({ cart_recommendations }: Props) {
  return (
    <SearchspringRecommendProvider category={"products"} tags={cart_recommendations.profile_id} limit={"2"}>
      <CartRecommendationsResultGrid recommendations={cart_recommendations} />
    </SearchspringRecommendProvider>
  );
}
